// 环境类型定义
export type Environment = 'development' | 'test' | 'production';

// 环境配置接口
export interface EnvConfig {
  API_BASE_URL: string;
  ENV: Environment;
  isDevelopment: boolean;
  isTest: boolean;
  isProduction: boolean;
}

// 获取当前环境
export const getCurrentEnv = (): Environment => {
  const env = process.env.REACT_APP_ENV as Environment;
  return env || 'development';
};

// 获取API基础URL
export const getApiBaseUrl = (): string => {
  const apiUrl = process.env.REACT_APP_API_BASE_URL;
  if (!apiUrl) {
    console.warn('REACT_APP_API_BASE_URL not found, using default localhost URL');
    return 'http://localhost:8000/api';
  } 
  return apiUrl;
};

// 环境配置对象
export const envConfig: EnvConfig = {
  API_BASE_URL: getApiBaseUrl(),
  ENV: getCurrentEnv(),
  isDevelopment: getCurrentEnv() === 'development',
  isTest: getCurrentEnv() === 'test',
  isProduction: getCurrentEnv() === 'production',
};

// 环境检查函数
export const isDevelopment = (): boolean => envConfig.isDevelopment;
export const isTest = (): boolean => envConfig.isTest;
export const isProduction = (): boolean => envConfig.isProduction;

// 调试日志函数（仅在非生产环境输出）
export const debugLog = (...args: any[]): void => {
  if (!isProduction()) {
    console.log('[DEBUG]', ...args);
  }
};

// 环境信息输出
export const logEnvInfo = (): void => {
  if (!isProduction()) {
    console.log('=== Environment Configuration ===');
    console.log('Environment:', envConfig.ENV);
    console.log('API Base URL:', envConfig.API_BASE_URL);
    console.log('Is Development:', envConfig.isDevelopment);
    console.log('Is Test:', envConfig.isTest);
    console.log('Is Production:', envConfig.isProduction);
    console.log('================================');
  }
};

// 默认导出
export default envConfig; 